import React, { useState, useEffect } from 'react';

import { getval2Token, setVal2Token } from '../../../Login/Auth';
import { SingleText } from '../../Res/BaseInput';
import { getCaseStatus, getCaseStatusString } from '../../../../item/ItemRecruitmentContractorStatus';
import { ReqRecruitmentContractorCaseInfo, VIEW_CASESTATUS1, VIEW_RESERVEDATE, VEW_CASEOWNER, VIEW_OVERDUE, VIEW_INVALID } from '../../../../item/ItemRecruitmentContractor';
import { ContentBox } from '../ContentBox';
import { SingleBigButton } from '../../Res/BaseButton';
import { ReviseReserveDate } from './ReviseReserveDate';
import { ReviseCaseOwner } from './ReviseCaseOwner';
import { ReviseOverdue } from './ReviseOverdue';
import { ReviseInvalid } from './ReviseInvalid';
import moment from 'moment';



export function ReviseSOPCaseStatus1({ id, setIsLoading, isEdit = false }) {
  const [tokenId, setTokenId] = useState("")
  const [item, setItem] = useState(null)
  const [vw_status, set_vw_status] = useState(<></>)
  const [content, setContent] = useState(<></>)

  useEffect(() => {
    if (id !== undefined && id !== tokenId) {
      var item = getval2Token("ReviseSOPCaseStatus1", id)
      setTokenId(id)
      setItem(item)
      // console.log(item)
      var mReqRecruitmentContractorCaseInfo = new ReqRecruitmentContractorCaseInfo({})
      mReqRecruitmentContractorCaseInfo.fromJson(item.caseInfo)
      set_vw_status(
        <>
          <SingleText title={"目前的 案件狀態"} val={item.caseContractorName + " " + getCaseStatusString(item, mReqRecruitmentContractorCaseInfo)} />
          <SingleText title={"目前的 預定上工日"} val={moment(mReqRecruitmentContractorCaseInfo.caseReserveDate).format('YYYY/MM/DD')} />
          <SingleText title={"目前的 案件管轄者"} val={item.caseOwnerName} />
        </>
      )
      //setContent(<ReviseView item={item} caseContractorName={caseContractorName} caseStatus={caseStatus} statusDate={statusDate} caseOwnerName={caseOwnerName} action={change} />)
    }
  }, [id])

  useEffect(() => {
    if (item !== null && tokenId !== null) {
      var view = getval2Token("view", tokenId)
      // console.log(view||VIEW_CASESTATUS1)
      change(view)
    }
  }, [item, tokenId])

  function change(val) {
    // console.log(item)
    switch (val) {
      case VIEW_RESERVEDATE:
        setContent(<ReviseReserveDate item={item} action={change} vw_status={vw_status} setIsLoading={setIsLoading} />)
        break;
      case VEW_CASEOWNER:
        setContent(<ReviseCaseOwner item={item} action={change} vw_status={vw_status} setIsLoading={setIsLoading} />)
        break;
      case VIEW_OVERDUE:
        setContent(<ReviseOverdue item={item} action={change} vw_status={vw_status} setIsLoading={setIsLoading} />)
        break;
      case VIEW_INVALID:
        setContent(<ReviseInvalid item={item} action={change} view={VIEW_CASESTATUS1} vw_status={vw_status} setIsLoading={setIsLoading} />)
        break;
      default:
        setContent(<ReviseView item={item} action={change} vw_status={vw_status}/>)
        break;
    }
    setVal2Token('view', val, tokenId)
  }

  return (
    <>{content}</>
  )

}

function ReviseView({ item, action, vw_status}) {
  const [mItem, setItem] = useState({})
  useEffect(() => {
    if (item !== undefined && item !== mItem) {
      setItem(item)
    }
  }, [item])


  function toReserveDate() {
    action(VIEW_RESERVEDATE)
  }
  function toCaseOwner() {
    action(VEW_CASEOWNER)
  }
  function toOverdue() {
    action(VIEW_OVERDUE)
  }
  function toCaseStatusInvalid() {
    action(VIEW_INVALID)
  }

  var superTitle = "請選擇要進行哪一種修正方式"
  var title = ""
  var content =
    <>
      <div className="row">
        <div className="col-md-12">
          {vw_status}
          {/* <SingleText title={"目前的 案件狀態"} val={caseContractorName + caseStatus} />
          <SingleText title={"目前的 預定上工日"} val={statusDate} />
          <SingleText title={"目前的 案件管轄者"} val={caseOwnerName} /> */}
        </div>
      </div>
      <div className="hr-line-dashed"></div>
      <div className="row">
        <div className="col-md-12">
          <SingleBigButton name={"校正 “預定上工日"} action={toReserveDate} />

          <div className="col-md-9">
            <p className="col-md-12">
              提示：主要是給“導入時期”使用的。系統正式使用時，不建議使用。</p>
          </div>
        </div>
      </div>

      <div className="hr-line-dashed"></div>

      <div className="row">
        <div className="col-md-12">
          <SingleBigButton name={"變更 “案件管轄者”"} action={toCaseOwner} size={3} />


          <div className="col-md-9">
            <p className="col-md-12">
              提示：如果原本的案件管轄者(招募員)離職了，請選用此修正方式，進行“派遣案件轉掛”</p>
          </div>
        </div>
      </div >

      <div className="hr-line-dashed"></div>

      <div className="row">
        <div className="col-md-12">
          <SingleBigButton name={"進行 “逾期報到作業”"} action={toOverdue} />


          <div className="col-md-9">
            <p className="col-md-12">
              提示：報到作業之SOP，限制報到作業，只能在“預定上工日”當日及次日進行操作。逾期時，請選用此修正方式！！</p>
            <p className="col-md-12">
              注意：請檢查該外派員工之加保情況！！</p>
            <p className="col-md-12">
              提示：此修正不能改變“預定上工日”！如果“預定上工日”與“實際上工日”不一樣，請先校正“預定上工日”。</p>
          </div >
        </div >
      </div >

      <div className="hr-line-dashed"></div>

      <div className="row">
        <div className="col-md-12">
          <SingleBigButton name={"作廢此 ”派遣案件“"} action={toCaseStatusInvalid} />


          <div className="col-md-9">
            <p className="col-md-12">
              如果選錯“外派員工”、“工作職缺”，由於牽涉甚廣，所以系統不支援變更。建議作廢此案件，請招募員重新進行正確的“預定作業”</p>
            <p className="col-md-12">
              注意：作廢後，無法復原！請三思而後行。案件作廢後，“招募績效”就不會統計此案了。</p>
          </div>
        </div >
      </div >
    </>

  return (
    <>
      <ContentBox superTitle={superTitle} title={title} titleSize={6} content={content} hasDrawer={false} />
    </>
  )
}

